// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brand-header {
  background-color: var(--color-header-background);
}

.brand-logo {
  padding: 10px;
}
.brand-logo img {
  height: 175px;
  width: 175px;
}

.brand-desc {
  font-size: 30px;
  font-weight: 700;
  text-align: center;
  color: var(--color-header-text);
}`, "",{"version":3,"sources":["webpack://./ClientApp/src/app/mobile/branding/branding.component.scss"],"names":[],"mappings":"AAAA;EACE,gDAAA;AACF;;AACA;EACE,aAAA;AAEF;AADE;EACE,aAAA;EACA,YAAA;AAGJ;;AAAA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;AAGF","sourcesContent":[".brand-header {\n  background-color: var(--color-header-background);\n}\n.brand-logo {\n  padding: 10px;\n  img {\n    height: 175px;\n    width: 175px;\n  }\n}\n.brand-desc {\n  font-size: 30px;\n  font-weight: 700;\n  text-align: center;\n  color: var(--color-header-text);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
